module.exports = __webpack_public_path__ + "static/media/partitions_gwp_10y_n.a4f23724.csv";